<template>
  <div class="footer-nav">
    <AppAccordion v-for="(accordion, index) in navFooterList"
      :key="index"
      :from-laptop="true"
      class="footer-nav__accordion">
      <template #header>
        {{ accordion.title }}
      </template>
      <ul class="footer-nav__accordion-list">
        <li v-for="navItem in accordion.links"
          :key="navItem.name"
          class="footer-nav__accordion-item">
          <a
            v-if="navItem.link.endsWith('.pdf')"
            :href="`https://resheniean.ru${navItem.link}`"
          >
            {{ navItem.name }}
          </a>
          <router-link v-else :to="navItem.link"
            class="footer-nav__accordion-go">
            {{ navItem.name }}
          </router-link>
        </li>
      </ul>
    </AppAccordion>

    <ul class="burger-list-mobile">
      <li v-for="item in burgerList" class="burger-list-mobile__item" style="color: white">
        <router-link :to="item.link" class="footer-nav__accordion-go">
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AppAccordion from "./ui/AppAccordion.vue";

export default {
  name: "FooterNav",
  components: { AppAccordion },

  props: {
    navFooterList: {
      type: Array,
      default: () => [],
    },
    burgerList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-nav {
  $that: &;

  display: flex;
  gap: 7px;

  @include laptop {
    display: block;
  }

  &__accordion {
    position: relative;
    flex: 0 0 fit-content;
    padding-right: 28px;

    @include laptop {
      padding-right: 0;
    }

    @include tablet {
      max-width: 284px;
    }

    @include phone {
      max-width: 100%;

      :deep .accordion__header {
        font-size: 16px;
        justify-content: flex-start;
        text-transform: uppercase;
        padding: 12px 0;
      }

      :deep .accordion__arrow {
        transform: rotate(-90deg);
      }

      :deep._is-open {
        .accordion__arrow {
          transform: rotate(0deg);
        }
      }

      // &::after {
      //   content: "";
      //   width: 100vw;
      //   height: 1px;
      //   background-color: $color_dark-70;
      //   position: absolute;
      //   bottom: 0;
      //   left: 50%;
      //   transform: translate3D(-50%, 0, 0);
      // }
    }
  }

  &__accordion-item {
    font-size: 14px;
    line-height: 18px;
    max-width: 160px;

    & + & {
      padding-top: 10px;

      @include laptop {
        padding-top: 16px;
      }
    }

    @include laptop {
      padding-left: 14px;
    }
  }

  &__accordion-go {
  }
}
.burger-list-mobile {
  padding-top: 12px;
  
  &__item {
    font-size: 16px;
    text-transform: uppercase;
    padding: 12px 0;
    color: #fff;
  }
}
</style>
